var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPainscore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 42.5,
    viewBox: "0 0 30.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator",
    transform: "translate(-11.75 -1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M39,44H15a3,3,0,0,1-3-3V5a3,3,0,0,1,3-3H39a3,3,0,0,1,3,3V41A3,3,0,0,1,39,44ZM15,3.2A1.8,1.8,0,0,0,13.2,5V41A1.8,1.8,0,0,0,15,42.8H39A1.8,1.8,0,0,0,40.8,41V5A1.8,1.8,0,0,0,39,3.2Z",
    transform: "translate(0 0)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M39.5,17.8H19.7a1.2,1.2,0,0,1-1.2-1.2V11.2A1.2,1.2,0,0,1,19.7,10H39.5a1.2,1.2,0,0,1,1.2,1.2v5.4A1.2,1.2,0,0,1,39.5,17.8ZM19.7,11.2v5.4H39.5V11.2Z",
    transform: "translate(-2.6 -3.2)",
    fill: "#0060a6",
    stroke: "#0060a6",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M49.858,33.842H46.733a1.026,1.026,0,0,1-1.025-1.025V29.692a1.027,1.027,0,0,1,1.025-1.025h3.125a1.027,1.027,0,0,1,1.025,1.025v3.125A1.026,1.026,0,0,1,49.858,33.842Zm-2.95-1.2h2.775V29.867H46.908Z",
    transform: "translate(-13.483 -10.667)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M36.837,33.842h-3.12a1.026,1.026,0,0,1-1.025-1.025V29.692a1.027,1.027,0,0,1,1.025-1.025h3.12a1.027,1.027,0,0,1,1.025,1.025v3.125a1.026,1.026,0,0,1-1.025,1.025Zm-2.95-1.2h2.775V29.867H33.89Z",
    transform: "translate(-8.277 -10.667)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M23.817,33.842H20.692a1.026,1.026,0,0,1-1.025-1.025V29.692a1.027,1.027,0,0,1,1.025-1.025h3.125a1.027,1.027,0,0,1,1.025,1.025v3.125A1.026,1.026,0,0,1,23.817,33.842Zm-2.95-1.2h2.775V29.867H20.867Z",
    transform: "translate(-3.067 -10.667)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M36.835,46.863h-3.12a1.027,1.027,0,0,1-1.027-1.028v-3.12a1.027,1.027,0,0,1,1.027-1.027h3.12a1.027,1.027,0,0,1,1.028,1.027v3.12a1.027,1.027,0,0,1-1.028,1.028Zm-2.95-1.2H36.66V42.888H33.888Z",
    transform: "translate(-8.275 -15.875)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M23.817,46.865H20.692a1.027,1.027,0,0,1-1.025-1.028v-3.12a1.027,1.027,0,0,1,1.025-1.025h3.125a1.027,1.027,0,0,1,1.025,1.025v3.12A1.027,1.027,0,0,1,23.817,46.865Zm-2.95-1.2h2.775V42.89H20.867Z",
    transform: "translate(-3.067 -15.877)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M49.859,54.675h-3.12a1.027,1.027,0,0,1-1.025-1.025V42.717a1.027,1.027,0,0,1,1.025-1.025h3.12a1.027,1.027,0,0,1,1.025,1.025V53.65A1.027,1.027,0,0,1,49.859,54.675Zm-2.947-1.2h2.772V42.891H46.912Z",
    transform: "translate(-13.486 -15.877)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M36.837,59.883h-3.12a1.027,1.027,0,0,1-1.025-1.025V55.733a1.026,1.026,0,0,1,1.025-1.025h3.12a1.026,1.026,0,0,1,1.025,1.025v3.125a1.027,1.027,0,0,1-1.025,1.025Zm-2.95-1.2h2.775V55.908H33.89Z",
    transform: "translate(-8.277 -21.083)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M23.817,59.883H20.692a1.027,1.027,0,0,1-1.025-1.025V55.734a1.026,1.026,0,0,1,1.025-1.025h3.125a1.026,1.026,0,0,1,1.025,1.025v3.125A1.027,1.027,0,0,1,23.817,59.883Zm-2.95-1.2h2.775V55.908H20.867Z",
    transform: "translate(-3.067 -21.084)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPainscore);
export default __webpack_public_path__ + "static/media/icon_painscore.3a1a5c5777ecbd17346d7eb31e3a7d45.svg";
export { ForwardRef as ReactComponent };